// OCTAGON INFINITY WHITEPAPER CONTENT
// Edit this file to update the whitepaper content

export const whitepaperContent = {
  title: "OCTAGON INFINITY",
  subtitle: "Real Estate Tokenization & NFT Investment Platform",
  version: "Version 1.0 - November 2025",
  
  sections: [
    {
      id: "executive-summary",
      title: "Executive Summary",
      content: `Octagon Infinity represents a revolutionary approach to real estate investment through blockchain technology and NFT tokenization. Our platform democratizes access to premium European real estate projects by offering 10,000 exclusive VIP passes that grant holders investment rights, profit-sharing opportunities, and governance participation.

Each VIP Pass NFT represents a €4,000 investment power in carefully curated real estate projects across Europe, with projected annual returns ranging from 12-25%. By combining traditional real estate investment with cutting-edge blockchain technology, we create a transparent, liquid, and accessible investment vehicle for the modern investor.`
    },
    
    {
      id: "problem-statement",
      title: "Problem Statement",
      content: `Traditional real estate investment faces several critical challenges:

• High Entry Barriers: Minimum investment requirements often exceed €100,000, excluding most investors
• Illiquidity: Real estate assets typically require months or years to sell
• Limited Transparency: Complex ownership structures and opaque profit distribution
• Geographic Constraints: Difficulty accessing international real estate markets
• Administrative Burden: Extensive paperwork and legal complexities

Octagon Infinity solves these problems through blockchain tokenization, creating fractional ownership opportunities with enhanced liquidity, transparency, and accessibility.`
    },
    
    {
      id: "solution",
      title: "Our Solution",
      content: `Octagon Infinity introduces a comprehensive NFT-based real estate investment ecosystem:

VIP Pass NFTs: 10,000 exclusive NFTs at 0.24 ETH each, representing €4,000 investment power
Tiered System: Multiple project tiers (0-3) with varying risk-return profiles
Rarity Levels: Common, Rare, Epic, and Legendary cards with multiplied returns
Profit Sharing: Monthly distributions based on project performance
Governance Rights: NFT holders participate in project selection and platform decisions
Secondary Market: Trade your VIP Pass on supported marketplaces for enhanced liquidity`
    },
    
    {
      id: "tokenomics",
      title: "Tokenomics & Investment Structure",
      content: `Investment Framework:
• Total VIP Passes: 10,000 NFTs
• Price per NFT: 0.24 ETH
• Base Investment Power: €4,000 per NFT
• Enhanced Investment Power: Multiplied by rarity (1.0x - 2.0x)

Project Tiers & Monthly Returns:
• Tier 0: 2% monthly return (24% annually)
• Tier 1: 4% monthly return (48% annually)  
• Tier 2: 6% monthly return (72% annually)
• Tier 3: 8% monthly return (96% annually)

Rarity Multipliers:
• Green Card (Common - 60%): 1.0x base investment power
• Bronze Card (Rare - 30%): 1.2x base investment power
• Silver Card (Epic - 8%): 1.5x base investment power
• Gold Card (Legendary - 2%): 2.0x base investment power

Profit Distribution:
Monthly distributions calculated as: (Base Investment Power × Rarity Multiplier × Monthly Return Rate)`
    },
    
    {
      id: "projects",
      title: "Featured Projects",
      content: `Prague Historic Apartments (Tier 1)
Prime real estate in Prague's historic center, featuring renovated apartments with strong rental demand and appreciation potential. Target Return: 12-18% annually.

Vienna Luxury Residences (Tier 2)
High-end residential development in Vienna's premium districts, catering to international executives and affluent families. Target Return: 18-22% annually.

Berlin Commercial Complex (Tier 2)
Mixed-use commercial development in Berlin's growing business district, combining retail, office, and co-working spaces. Target Return: 20-25% annually.

Barcelona Coastal Properties (Tier 3)
Mediterranean beachfront properties with tourism and vacation rental income streams. Target Return: 22-25% annually.`
    },
    
    {
      id: "technology",
      title: "Technology & Security",
      content: `Blockchain Infrastructure:
Built on secure, audited smart contracts ensuring transparent ownership and automated profit distribution.

NFT Standards:
ERC-721 compliant tokens with metadata storing investment rights and rarity levels.

Security Measures:
• Multi-signature wallets for fund management
• Regular third-party security audits
• Transparent on-chain transaction history
• KYC/AML compliance for all participants

Platform Features:
• Real-time ROI calculator
• Portfolio tracking dashboard
• Automated profit distribution
• Secondary market integration
• Mobile-responsive interface`
    },
    
    {
      id: "team",
      title: "Team & Advisors",
      content: `Our team combines expertise in real estate development, blockchain technology, and financial services:

Real Estate Experts: 50+ years combined experience in European property development and management.

Blockchain Specialists: Core developers with proven track record in DeFi and NFT platforms.

Legal & Compliance: Experienced attorneys ensuring regulatory compliance across all jurisdictions.

Financial Advisors: Former investment bankers and asset managers guiding strategy and risk management.`
    },
    
    {
      id: "roadmap",
      title: "Roadmap",
      content: `Q4 2025: Platform Launch & NFT Minting
• Website launch and community building
• VIP Pass NFT minting begins
• First project announcements

Q1 2026: Initial Investments & Operations
• Deploy capital to first 3-5 projects
• Begin monthly profit distributions
• Launch secondary marketplace

Q2 2026: Expansion & New Projects
• Add 5-10 new real estate projects
• Expand to additional European markets
• Introduce governance voting

Q3-Q4 2026: Advanced Features
• Launch mobile application
• Integrate DeFi lending protocols
• Expand to 50+ active projects
• Global market expansion planning`
    },
    
    {
      id: "risks",
      title: "Risk Factors",
      content: `Investment Considerations:

Market Risk: Real estate values and rental income may fluctuate based on economic conditions.

Regulatory Risk: Cryptocurrency and tokenized securities face evolving regulatory frameworks.

Liquidity Risk: While NFTs enhance liquidity, secondary market depth may vary.

Project-Specific Risk: Individual real estate projects carry development and operational risks.

Technology Risk: Smart contract vulnerabilities or blockchain network issues could impact operations.

Mitigation Strategies:
• Diversified project portfolio across markets and property types
• Conservative financial projections and risk assessments
• Regular security audits and insurance coverage
• Compliance with all applicable regulations
• Transparent reporting and communication`
    },
    
    {
      id: "legal",
      title: "Legal & Compliance",
      content: `Regulatory Framework:
Octagon Infinity operates in full compliance with EU regulations regarding tokenized securities and real estate investment.

Investor Protection:
All participants complete KYC/AML verification. Investment terms clearly disclosed in legal documentation.

Jurisdictions:
Structured to comply with regulations in key European markets including Germany, Austria, Czech Republic, and Spain.

Tax Considerations:
Investors responsible for tax obligations in their jurisdiction. Platform provides necessary documentation for reporting.`
    },
    
    {
      id: "conclusion",
      title: "Conclusion",
      content: `Octagon Infinity bridges traditional real estate investment with blockchain innovation, creating unprecedented opportunities for investors worldwide. Our VIP Pass NFTs provide:

✓ Accessible entry point (0.24 ETH) to premium real estate
✓ Projected returns of 12-25% annually
✓ Enhanced liquidity through NFT tradability
✓ Transparent, blockchain-verified ownership
✓ Diversified exposure to European property markets
✓ Professional management and governance rights

Join the future of real estate investment. Secure your VIP Pass and become part of the Octagon Infinity community.`
    },
    
    {
      id: "contact",
      title: "Contact & Resources",
      content: `Website: octagon8.io
Email: info@octagon8.io
Support: support@octagon8.io

Social Media:
Follow us for updates, project announcements, and community discussions.

Documentation:
• Terms of Service
• Privacy Policy  
• Risk Disclosure
• Investment Agreement

Join Our Community:
Connect with fellow investors, discuss projects, and stay informed about platform developments.`
    }
  ]
};
